import React, { useEffect } from 'react';
import { CheckCircleIcon, XCircleIcon } from '@heroicons/react/24/outline';

interface ToastProps {
  message: string;
  type: 'success' | 'error';
  onClose: () => void;
  duration?: number;
}

const Toast: React.FC<ToastProps> = ({ 
  message, 
  type = 'success', 
  onClose,
  duration = 3000 
}) => {
  useEffect(() => {
    const timer = setTimeout(() => {
      onClose();
    }, duration);

    return () => clearTimeout(timer);
  }, [duration, onClose]);

  return (
    <div className="fixed bottom-4 right-4 z-50 animate-slide-up">
      <div className={`flex items-center gap-2 px-4 py-3 rounded-lg shadow-lg ${
        type === 'success' 
          ? 'bg-primary-500/10 border border-primary-500/20' 
          : 'bg-red-500/10 border border-red-500/20'
      }`}>
        {type === 'success' ? (
          <CheckCircleIcon className="w-5 h-5 text-primary-500" />
        ) : (
          <XCircleIcon className="w-5 h-5 text-red-500" />
        )}
        <p className={`text-sm font-medium ${
          type === 'success' ? 'text-primary-500' : 'text-red-500'
        }`}>
          {message}
        </p>
      </div>
    </div>
  );
};

export default Toast;